import React, {useEffect, useState} from 'react';
import _ from "lodash";
import {
    searchPrintfulSyncProductsSyncsWithSearchCriteria
} from "../../services/printful-sync-products-sync-data.service";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";
import {
    PRINTFUL_SYNC_PRODUCTS_SYNC_BATCHES_FIELDS_LIST,
    PRINTFUL_SYNC_PRODUCTS_SYNC_FIELDS_LIST
} from "../../constants/printful-sync-products-sync.constant";
import {getSinglePrintfulSyncs} from "../../services/printful-syncs-data.service";
import {PRINTFUL_INFO_IDS} from "../../constants/printful-info.constant";
import {showDateTime} from "../../utils/printful-util";


const defaultFilterCriteria: any = {};

const PrintfulSyncProductsSyncsList = () => {
    const [printfulSyncProductsSyncsList, setPrintfulSyncProductsSyncsList] = useState(null);
    const [filterCriteria, setFilterCriteria] = useState(defaultFilterCriteria);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(true);

    const getPrintfulSyncProductsSyncList = async () => {
        setDataFetchInProgress(true);

        const searchCriteriaList = [];

        _.forIn(filterCriteria, (value, attribute) => {
            if ((!_.isEmpty(value) || value === true) && value !== 'EMPTY') {
                searchCriteriaList.push({field: attribute, condition: '==', value: value});
            }
        });

        // const printfulSyncProductsSyncListResult = await searchPrintfulSyncProductsSyncsWithSearchCriteria(searchCriteriaList);
        const printfulSyncProductsSyncResult = await getSinglePrintfulSyncs(PRINTFUL_INFO_IDS.PRINTFUL_SYNC_PRODUCTS_SYNC);

        console.log('printfulSyncProductsSyncResult', printfulSyncProductsSyncResult);

        setPrintfulSyncProductsSyncsList([printfulSyncProductsSyncResult]);
        setDataFetchInProgress(false);
    }

    useEffect(() => {
        getPrintfulSyncProductsSyncList();
    }, [filterCriteria]);

    const refreshPrintfulSyncProductsSyncList = async () => {
        await getPrintfulSyncProductsSyncList();
    }

    return (
        <>

            <div className="flex justify-between">

                <div className="flex justify-start items-center mt-2 -ml-2 mb-2 w-full">
                    <div className={'text-xl ml-2'}>
                        Printful Sync Products Sync
                    </div>

                    {/*<PrintfulSyncProductsSyncFilters
                        filterCriteria={filterCriteria}
                        setFilterCriteria={setFilterCriteria}/>*/}

                    <div className="ml-4">
                        <ShowProgressSpinner dataFetchInProgress={dataFetchInProgress}/>
                    </div>
                </div>

                <div className="text-center w-1/3 flex items-center justify-end">
                    <div>
                        <button
                            className="button-green px-4 py-2 flex items-center justify-center"
                            onClick={refreshPrintfulSyncProductsSyncList}>
                            <span>Refersh Sync Products Sync</span>
                        </button>
                    </div>
                </div>

            </div>

            <div className="justify-start">

                <div
                    className="w-full bg-white mt-4">

                    <ShowEmptyListMessage
                        dataList={printfulSyncProductsSyncsList}
                        dataFetchInProgress={dataFetchInProgress}
                        label={'Printful Sync Products Syncs'}/>

                    {printfulSyncProductsSyncsList?.length > 0 &&
                        <table className="w-full">
                            <thead className="">
                            <tr>
                                <th className="p-2 border border-gray-400 bg-gray-400 text-white w-12">S.No</th>
                                {PRINTFUL_SYNC_PRODUCTS_SYNC_FIELDS_LIST?.map((printfulSyncProductsSyncField, rowIndex) => (
                                    <th key={`th-${rowIndex}`}
                                        className={`p-2 border border-gray-400 bg-gray-400 text-white text-left pl-2 ${printfulSyncProductsSyncField?.cssClass}`}>{printfulSyncProductsSyncField?.label}</th>
                                ))}
                            </tr>
                            </thead>
                            <tbody className="">
                            {printfulSyncProductsSyncsList?.map((printfulSyncProductsSync, rowIndex) => (
                                <tr key={`row-${rowIndex}`} className="border border-gray-400">
                                    <td className="p-2 border border-gray-400 m-auto">
                                        <div className="flex justify-center w-12">
                                            {rowIndex + 1}
                                        </div>
                                    </td>

                                    {PRINTFUL_SYNC_PRODUCTS_SYNC_FIELDS_LIST?.map((printfulSyncProductsSyncField, columnIndex) => (
                                        <React.Fragment key={`column-${rowIndex}-${columnIndex}`}>
                                            <td className={`p-2 border border-gray-400 m-auto ${printfulSyncProductsSyncField?.cssClass}`}>
                                                {printfulSyncProductsSyncField?.optionsMap &&
                                                    <>{printfulSyncProductsSyncField?.optionsMap[printfulSyncProductsSync[printfulSyncProductsSyncField?.attribute]]?.name}</>
                                                }

                                                {!printfulSyncProductsSyncField?.optionsMap &&
                                                    <>
                                                        {!printfulSyncProductsSyncField?.isDate && !printfulSyncProductsSyncField?.isBoolean &&
                                                            <>
                                                                {printfulSyncProductsSync[printfulSyncProductsSyncField?.attribute]}
                                                            </>
                                                        }

                                                        {printfulSyncProductsSyncField?.isDate &&
                                                            <>
                                                                {showDateTime(printfulSyncProductsSync[printfulSyncProductsSyncField?.attribute])}
                                                            </>
                                                        }

                                                        {printfulSyncProductsSyncField?.isBoolean &&
                                                            <>
                                                                {printfulSyncProductsSync[printfulSyncProductsSyncField?.attribute] ? 'Yes' : 'No'}
                                                            </>
                                                        }

                                                        {printfulSyncProductsSyncField?.secondaryAttribute &&
                                                            <div className={'text-gray-500 text-sm'}>
                                                                {printfulSyncProductsSync[printfulSyncProductsSyncField?.secondaryAttribute]}
                                                            </div>
                                                        }
                                                    </>
                                                }
                                            </td>
                                        </React.Fragment>
                                    ))}
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    }
                </div>

                <div className={'text-xl mt-8'}>Batches</div>

                <div
                    className="w-full bg-white mt-4">

                    {printfulSyncProductsSyncsList && printfulSyncProductsSyncsList[0]?.batches?.length > 0 &&
                        <table className="w-full">
                            <thead className="">
                            <tr>
                                <th className="p-2 border border-gray-400 bg-gray-400 text-white w-12">S.No</th>
                                {PRINTFUL_SYNC_PRODUCTS_SYNC_BATCHES_FIELDS_LIST?.map((batchField, rowIndex) => (
                                    <th key={`th-${rowIndex}`}
                                        className={`p-2 border border-gray-400 bg-gray-400 text-white text-left pl-2 ${batchField?.cssClass}`}>{batchField?.label}</th>
                                ))}
                            </tr>
                            </thead>
                            <tbody className="">
                            {printfulSyncProductsSyncsList[0]?.batches?.map((batch, rowIndex) => (
                                <tr key={`row-${rowIndex}`} className="border border-gray-400">
                                    <td className="p-2 border border-gray-400 m-auto">
                                        <div className="flex justify-center w-12">
                                            {rowIndex + 1}
                                        </div>
                                    </td>

                                    {PRINTFUL_SYNC_PRODUCTS_SYNC_BATCHES_FIELDS_LIST?.map((batchField, columnIndex) => (
                                        <React.Fragment key={`column-${rowIndex}-${columnIndex}`}>
                                            <td className={`p-2 border border-gray-400 m-auto ${batchField?.cssClass}`}>
                                                {batchField?.optionsMap &&
                                                    <>{batchField?.optionsMap[batch[batchField?.attribute]]?.name}</>
                                                }

                                                {!batchField?.optionsMap &&
                                                    <>
                                                        {!batchField?.isDate && !batchField?.isBoolean &&
                                                            <>
                                                                {batch[batchField?.attribute]}
                                                            </>
                                                        }

                                                        {batchField?.isDate &&
                                                            <>
                                                                {showDateTime(batch[batchField?.attribute])}
                                                            </>
                                                        }

                                                        {batchField?.isBoolean &&
                                                            <>
                                                                {batch[batchField?.attribute] ? 'Yes' : 'No'}
                                                            </>
                                                        }

                                                        {batchField?.secondaryAttribute &&
                                                            <div className={'text-gray-500 text-sm'}>
                                                                {batch[batchField?.secondaryAttribute]}
                                                            </div>
                                                        }
                                                    </>
                                                }
                                            </td>
                                        </React.Fragment>
                                    ))}
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    }
                </div>

            </div>

        </>
    )
}

export default PrintfulSyncProductsSyncsList
